import { api } from "shared/redux/api"
import { useMutationWithCallbacks } from "../../hooks/useMutationWithCallbacks"
import { objectToQueryString } from "shared/utils/common"
import { get } from "lodash"

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getTeachers: build.query({
      query: (arg) => {
        return {
          url: `/private/teacher/v1${
            arg ? `?${objectToQueryString(arg)}` : ""
          }`,
        }
      },
    }),
    getCenters: build.query({
      query: (arg) => {
        return {
          url: `/private/event/v1/block/center${
            arg ? `?${objectToQueryString(arg)}` : ""
          }`,
        }
      },
    }),
    getPerformanceLXO: build.query({
      query: (arg) => {
        return {
          url: `/private/lxo/v1/performance${
            arg ? `?${objectToQueryString(arg)}` : ""
          }`,
        }
      },
    }),
    getClassSituation: build.query({
      query: (arg) => {
        return {
          url: `/private/my-assistant/v1/class-situation${
            arg ? `?${objectToQueryString(arg)}` : ""
          }`,
          method: "GET",
        }
      },
      transformResponse: (response) => {
        return response?.data ?? null
      },
    }),
    getClassSituationSelection: build.query({
      query: (arg) => {
        return {
          url: `/private/my-assistant/v1/class-situation/selection`,
          method: "GET",
        }
      },
      transformResponse: (response) => {
        return response?.data?.data ?? null
      },
    }),
    getClassSituationSelectionScheduleDay: build.query({
      query: (arg) => {
        return {
          url: `/private/my-assistant/v1/class-situation/schedule-day${
            arg ? `?${objectToQueryString(arg)}` : ""
          }`,
          method: "GET",
        }
      },
      transformResponse: (response) => {
        return response?.data ?? null
      },
    }),
    getClassSituationSelectionCourseGroupName: build.query({
      query: (arg) => {
        return {
          url: `/private/my-assistant/v1/class-situation/course-group-name${
            arg ? `?${objectToQueryString(arg)}` : ""
          }`,
          method: "GET",
        }
      },
      transformResponse: (response) => {
        return response?.data ?? null
      },
    }),
    getClassSituationSelectionLevelName: build.query({
      query: (arg) => {
        return {
          url: `/private/my-assistant/v1/class-situation/level-name${
            arg ? `?${objectToQueryString(arg)}` : ""
          }`,
          method: "GET",
        }
      },
      transformResponse: (response) => {
        return response?.data ?? null
      },
    }),
    getClassSituationSelectionCXO: build.query({
      query: (arg) => {
        return {
          url: `/private/my-assistant/v1/class-situation/cxo${
            arg ? `?${objectToQueryString(arg)}` : ""
          }`,
          method: "GET",
        }
      },
      transformResponse: (response) => {
        return response?.data ?? null
      },
    }),
    getClassSituationSelectionClassStatus: build.query({
      query: (arg) => {
        return {
          url: `/private/my-assistant/v1/class-situation/class-status${
            arg ? `?${objectToQueryString(arg)}` : ""
          }`,
          method: "GET",
        }
      },
      transformResponse: (response) => {
        return response?.data ?? null
      },
    }),
    getClassSituationSelectionTeacherName: build.query({
      query: (arg) => {
        return {
          url: `/private/my-assistant/v1/class-situation/teacher-name${
            arg ? `?${objectToQueryString(arg)}` : ""
          }`,
          method: "GET",
        }
      },
      transformResponse: (response) => {
        return response?.data ?? null
      },
    }),
    getCalendarLXO: build.query({
      query: (arg) => {
        return {
          url: `/private/lxo/v1/calendar${
            arg ? `?${objectToQueryString(arg)}` : ""
          }`,
        }
      },
    }),
    getDashBoard: build.query({
      query: (arg) => {
        const { centerId } = arg
        return {
          url: `/private/lxo/v1/kpi?centerId=${centerId}`,
        }
      },
    }),
    getTeacherTypes: build.query({
      query: (arg) => {
        const { type, ...options } = arg
        return {
          url: `/private/lxo/v1/types/${type}?${objectToQueryString(options)}`,
        }
      },
    }),
    createEventCalendar: build.mutation({
      query: (arg) => ({
        url: "/private/event/v1",
        method: "POST",
        body: arg,
      }),
    }),
    getTeacherCalendar: build.query({
      query: (arg) => {
        return {
          url: `/private/lxo/v2/calendar${
            arg ? `?${objectToQueryString(arg)}` : ""
          }`,
        }
      },
    }),
    getTeacherCount: build.query({
      query: (arg) => {
        return {
          url: `/private/lxo/v2/count${
            arg ? `?${objectToQueryString(arg)}` : ""
          }`,
        }
      },
    }),
    getTeacherChangeLXO: build.query({
      query: (arg) => {
        return {
          url: `/private/lxo/v1/teacher-change${
            arg ? `?${objectToQueryString(arg)}` : ""
          }`,
        }
      },
    }),
    getTeachersLXO: build.query({
      query: (arg) => {
        return {
          url: `/private/lxo/v1/teachers${
            arg ? `?${objectToQueryString(arg)}` : ""
          }`,
        }
      },
    }),
    getLeaveCalenDar: build.query({
      query: (arg) => {
        return {
          url: `/private/leave/v1/calendar${
            arg ? `?${objectToQueryString(arg)}` : ""
          }`,
        }
      },
    }),
    getNotiApprovalLeave: build.query({
      query: (arg) => {
        return {
          url: `/private/leave/v1/options`,
        }
      },
    }),
    getVisaLXO: build.query({
      query: (arg) => {
        return {
          url: `/private/lxo/v2/teachers${
            arg ? `?${objectToQueryString(arg)}` : ""
          }`,
        }
      },
    }),
    getLeaveLXO: build.query({
      query: (arg) => {
        return {
          url: `/private/leave/v1${arg ? `?${objectToQueryString(arg)}` : ""}`,
        }
      },
    }),
    getLeaveLXOV3: build.query({
      query: (arg) => {
        return {
          url: `/private/leave/v3${arg ? `?${objectToQueryString(arg)}` : ""}`,
        }
      },
    }),
    getStoryTeamLXO: build.query({
      query: (teamId) => {
        return {
          url: `/private/lxo/v2/team/${teamId}`,
        }
      },
    }),
    getMyStoryStatus: build.query({
      query: () => {
        return {
          url: "/private/user/v1/story-status",
          method: "GET",
        }
      },
      transformResponse: (response) => {
        return response?.data ?? null
      },
    }),
    addStoryStatus: build.mutation({
      query: (body) => {
        return {
          url: "/private/user/v1/story-status",
          method: "POST",
          body,
        }
      },
    }),
  }),
  overrideExisting: false,
})

export const {
  useLazyGetTeachersQuery,
  useLazyGetCentersQuery,
  useLazyGetPerformanceLXOQuery,
  useLazyGetClassSituationQuery,
  useLazyGetClassSituationSelectionQuery,
  useLazyGetClassSituationSelectionScheduleDayQuery,
  useLazyGetClassSituationSelectionCourseGroupNameQuery,
  useLazyGetClassSituationSelectionLevelNameQuery,
  useLazyGetClassSituationSelectionCXOQuery,
  useLazyGetClassSituationSelectionClassStatusQuery,
  useLazyGetClassSituationSelectionTeacherNameQuery,
  useLazyGetCalendarLXOQuery,
  useLazyGetDashBoardQuery,
  useLazyGetTeacherTypesQuery,
  useCreateEventCalendarMutation,
  useLazyGetTeacherCalendarQuery,
  useLazyGetTeacherCountQuery,
  useLazyGetTeacherChangeLXOQuery,
  useLazyGetTeachersLXOQuery,
  useLazyGetLeaveCalenDarQuery,
  useLazyGetNotiApprovalLeaveQuery,
  useLazyGetVisaLXOQuery,
  useLazyGetLeaveLXOQuery,
  useLazyGetStoryTeamLXOQuery,
  useLazyGetMyStoryStatusQuery,
  useAddStoryStatusMutation,
  useLazyGetLeaveLXOV3Query,
} = injectedRtkApi
